import { Component } from '@angular/core';
import BaseComponent from '../BaseComponent';

@Component({
  selector: 'app-components-ticket-invalid-url',
  templateUrl: './invalid-url.component.html'
})
export class InvalidUrlComponent extends BaseComponent {
  customerJS: Boo.Objects.Customer;
  customerCampaignRestrictions: Boo.Objects.CustomerCampaign.Enums.RestrictionTypes[] = [
    Boo.Objects.CustomerCampaign.Enums.RestrictionTypes.DisableTaskActions,
    Boo.Objects.CustomerCampaign.Enums.RestrictionTypes.DisableCustomerCampaignType,
    Boo.Objects.CustomerCampaign.Enums.RestrictionTypes.HideStrategyUpdateRequestButton
  ];

  canActivate?(_user: Boo.Objects.User, _partner: Boo.Objects.Partner, params: any): boolean {
    this.customerJS = ko.mapping.toJS(params.customer);
    return true;
  }
}
  